/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：126
 */

"use strict"

var r
var i
var o
export { r as b }
export { i as a }
export { o as f }
export { s as h }
export { a as d }
export { l as e }
export { c }
export { u as g };
(function (e) {
  e.SCALE_BTN = "scale_btn"
  e.ROTATE_BTN = "rotate_btn"
  e.MENU_BTN = "menu_btn"
  e.ROTATION_CENTER = "rotation_center"
  e.BORDER_LINE = "border_line"
})(r || (r = {}));
(function (e) {
  e.THINKING = "thinking"
  e.SAYING = "saying"
})(i || (i = {}));
(function (e) {
  e.Actor = "actor"
  e.Video = "video"
})(o || (o = {}))
var a
var s = 1
!function (e) {
  e[e.TURNING_ON = 0] = "TURNING_ON"
  e[e.IS_TURNED_ON = 1] = "IS_TURNED_ON"
  e[e.TURN_OFF = 2] = "TURN_OFF"
}(a || (a = {}))
var c
var u
var l = {
  fontSize: 20,
  fontFamily: "PingFangSC-Medium",
  fill: 12698564
}
!function (e) {
  e[e.COOPERATION_CONTAINER = 1] = "COOPERATION_CONTAINER"
  e[e.BORDER_BOX = 2] = "BORDER_BOX"
  e[e.EDITOR = 3] = "EDITOR"
  e[e.GRID = 4] = "GRID"
  e[e.DRAGGABLE_CONTAINER = 5] = "DRAGGABLE_CONTAINER"
  e[e.VOICE_DIALOG = 6] = "VOICE_DIALOG"
  e[e.STAGE_DIALOG = 7] = "STAGE_DIALOG"
  e[e.SELECTION_DIALOG = 8] = "SELECTION_DIALOG"
  e[e.TRANSLATE_DIALOG = 9] = "TRANSLATE_DIALOG"
}(c || (c = {}));
(function (e) {
  e[e.CAMERA = 0] = "CAMERA"
  e[e.PLAYABLE_CONTAINER = 1] = "PLAYABLE_CONTAINER"
})(u || (u = {}))
export default i
